import { render, staticRenderFns } from "./TabelaMandatos.vue?vue&type=template&id=4a301b16"
import script from "./TabelaMandatos.vue?vue&type=script&lang=js"
export * from "./TabelaMandatos.vue?vue&type=script&lang=js"
import style0 from "./TabelaMandatos.vue?vue&type=style&index=0&id=4a301b16&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports